import { DEV_SCRATCH_DOC } from '@awwyeah/shared';
import type { WebModule } from '../registry';
import { SyncScratchPage } from './SyncScratchPage';

/**
 * Dev module — TEMPORARY (WS-1). Hosts `/dev/sync`, the manual + torture-suite proving
 * ground for the sync layer. Delete once Phase 1 ships.
 *
 * No `nav` entry (owner call, 2026-07-31, docs/DECISIONS.md): it no longer takes a nav/tab
 * slot. Settings links to it from a small "Developer" section instead.
 */
export const devWebModule: WebModule = {
  id: 'dev',
  routes: [{ path: '/dev/sync', component: SyncScratchPage }],
  docs: [DEV_SCRATCH_DOC],
};
